import type React from "react"
import { Tag, Tooltip } from "antd"
import { IconBrandApple, IconBrandAndroid, IconDeviceDesktop, IconDeviceMobile } from "@tabler/icons-react"
import { parseUserAgent } from "@/utils/userAgent"

interface DeviceBadgeProps {
  userAgent?: string | null
  ipAddress?: string | null
  showDetails?: boolean
  className?: string
}

export const DeviceBadge: React.FC<DeviceBadgeProps> = ({
  userAgent,
  ipAddress,
  showDetails = false,
  className = "",
}) => {
  if (!userAgent && !ipAddress) return <span className="text-gray-400 text-xs">—</span>

  const info = userAgent ? parseUserAgent(userAgent) : null

  let color = "default"
  let icon = <IconDeviceMobile size={13} className="mr-1 inline" />

  if (info?.platform === "iOS") {
    color = "geekblue"
    icon = <IconBrandApple size={13} className="mr-1 inline" />
  } else if (info?.platform === "Android") {
    color = "green"
    icon = <IconBrandAndroid size={13} className="mr-1 inline" />
  } else if (info?.platform === "Desktop") {
    color = "purple"
    icon = <IconDeviceDesktop size={13} className="mr-1 inline" />
  }

  return (
    <Tooltip
      title={
        <div className="max-w-xs space-y-1 text-xs">
          {info && (
            <>
              <div>
                <strong>Nền tảng:</strong> {info.platform} ({info.os})
              </div>
              <div>
                <strong>Trình duyệt:</strong> {info.browser}
              </div>
            </>
          )}
          {ipAddress && (
            <div>
              <strong>Địa chỉ IP:</strong> <span className="font-mono text-cyan-300">{ipAddress}</span>
            </div>
          )}
          {userAgent && (
            <div className="break-all border-gray-600 border-t pt-1 font-mono text-[11px] text-gray-300">{userAgent}</div>
          )}
        </div>
      }
    >
      <Tag color={color} className={`font-medium text-xs ${className}`}>
        {icon}
        {info ? (showDetails ? info.label : info.platform) : "Thiết bị"}
      </Tag>
    </Tooltip>
  )
}

export default DeviceBadge
